<template>
    <MetaInfo :title="meta.title" :description="meta.description"></MetaInfo>
  
    <navigation></navigation>
  
    <PageHeader title="Text Messaging Terms"></PageHeader>
  
    <div class="container-fluid">
      <div class="row mb-30">
        <div class="col-xs-12 col-md-3 mb-20">
          <TermsNav></TermsNav>
        </div>
        <div class="col-xs-12 col-md-6 col-md-offset-1">
          <div class="longform">
            <p>
                Transpond text messaging credit plans are currently only available to send SMS campaigns to UK phone numbers.
            </p>
            <p>
                Customers are billed on a recurring monthly basis for the credit plan selected, based on prices published on our Website or full pricing which is available from within the application. These fees are in addition to your monthly or annual marketing contact plan and subject to the same payment terms.
            </p>
            <p>
                Following the set-up of your Text Messaging credit plan, customers on monthly plans, will pay for a full month in advance and immediately receive access to use the full monthly balance of credits until the end of that billing period. If you are on an annual marketing contact plan then the pro-rata fee will be for the remaining period of that year. The credit balance will reset monthly on an annual plan, based on the day in the month you started paying your marketing contact plan. Remaining credit balances will not be carried over from one billing period to the next, the credit limits will reset each billing period. There will be no refund or credit for partial credit usage in a billing period. Transpond reserves the right to cancel your Text Messaging credit plan for any failed payment.
            </p>
            <p>
                If the number of credits used exceeds your current credit count during the billing period, you will be automatically upgraded to the next relevant credit limit and you will receive an immediate prorated charge for the remaining period of the month or year, calculated in accordance with the new credit limit. Customers will receive warning emails as they get close to their credit limit, to warn them that they may exceed their credit limit with information about the charges that will then be applied to their plan for the excess usage. If the number of credits in an account goes below the current credit limit, the account will not automatically be downgraded to a lower plan.
            </p>
            <p>
                All credits used on your Transpond account will be chargeable and count towards your credit limit including non-delivered text messages outside the UK.
            </p>
            <p>
                You can cancel your Text Messaging credit plan from the account settings page of your Transpond account at any time. Cancelling your Transpond account will disable Text Messaging immediately.
            </p>
            <p>
                We may limit the number of messages or the time of day you can send messages as part of Text Messaging. By using Text Messaging, you agree to:
            </p>
            <ul>
                <li>
                    not send SMS messages to anyone you do not have the required consent to contact or without the required opt-out method or language within the SMS message;
                </li>
                <li>
                    not send any content that is in violation of our <a title="Acceptable Use Policy" href="/acceptableuse/">Acceptable Use Policy</a>;
                </li>
                <li>
                    comply with all laws, rules, regulations, best practices, policies, or carrier requirements applicable to Text Messaging (including, but not limited to, TPS/ CTPS restrictions in the UK, SHAFT restrictions, quiet hours, advertising restrictions, and direct marketing rules).
                </li>
                <li>
                    within the time period prescribed under applicable laws, rules, or regulations action all opt-out, unsubscribes, or other requests from Contacts who do not want to be contacted via Text Messaging.
                </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  
    <site-footer></site-footer>
  </template>
  
  <script>
  import MetaInfo from "@/components/MetaInfo";
  import Navigation from "@/components/navigation/Main";
  import SiteFooter from "@/components/SiteFooter";
  import TermsNav from "@/components/Terms/TermsNav";
  import PageHeader from "@/components/Header/PageHeader";
  
  export default {
    name: "TextMessagingTerms",
    components: {
      MetaInfo,
      Navigation,
      SiteFooter,
      TermsNav,
      PageHeader,
    },
  
    data() {
      return {
        meta: {
          title: "Text Messaging Terms - Transpond",
          description:
            "Take a look at the terms and conditions for using SMS on the Transpond Platform",
        },
      };
    },
  };
  </script>
  